import { getCookie } from "../mixins/cookies";

const CONSTANTS = {
  MIDDLEWARE: "https://parent.api.pre.education.nsw.gov.au",
  SCHOOL_STATUS: "https://api.dev.educationapp.nsw.edu.au/v2",
  EDPUSH_REGISTER:
    "https://edpush.api.pre.education.nsw.gov.au/api/v1/notifications/device/register-UUID",
  SCHOOL_PAYMENT_SUFFIX:
    "65.pre.schools.nsw.gov.au/payment.html#/student-details",
  FETCH_USER_DATA:
    "https://dev-doe-snsw.auth.ap-southeast-2.amazoncognito.com/oauth2/userInfo",
  PARENT_DEFAULT_ESSENTIALS:
    "https://portal.test.education.nsw.gov.au/portaldata/schools_default_essentials.json",
  VUE_APP_API_SCHOOL_ESSENTIALS:
    "https://bookmarks.api.test.education.nsw.gov.au/test/essentials/",
  FETCH_NOTIFICATIONS:
    "https://parent.api.dev.education.nsw.gov.au/notifications",
};

let environment = getCookie("environment");

if (environment) {
  // cookie based environment variables
  switch (environment) {
    case "dev":
      CONSTANTS.MIDDLEWARE = "https://parent.api.dev.education.nsw.gov.au";
      CONSTANTS.SCHOOL_STATUS = "https://api.dev.educationapp.nsw.edu.au/v2";
      CONSTANTS.EDPUSH_REGISTER =
        "https://edpush.api.pre.education.nsw.gov.au/api/v1/notifications/device/register-UUID";
      CONSTANTS.SCHOOL_PAYMENT_SUFFIX =
        "65.pre.schools.nsw.gov.au/payment.html#/student-details";
      CONSTANTS.FETCH_USER_DATA =
        "https://dev-doe-snsw.auth.ap-southeast-2.amazoncognito.com/oauth2/userInfo";
      CONSTANTS.PARENT_DEFAULT_ESSENTIALS =
        "https://portal.test.education.nsw.gov.au/portaldata/schools_default_essentials.json";
      CONSTANTS.SCHOOL_ESSENTIALS =
        "https://bookmarks.api.test.education.nsw.gov.au/test/essentials/";
      CONSTANTS.FETCH_NOTIFICATIONS =
        "https://parent.api.dev.education.nsw.gov.au/notifications";
      break;
    case "test":
      CONSTANTS.MIDDLEWARE = "https://parent.api.test.education.nsw.gov.au";
      CONSTANTS.SCHOOL_STATUS = "https://api.dev.educationapp.nsw.edu.au/v2";
      CONSTANTS.EDPUSH_REGISTER =
        "https://edpush.api.pre.education.nsw.gov.au/api/v1/notifications/device/register-UUID";
      CONSTANTS.SCHOOL_PAYMENT_SUFFIX =
        "65.pre.schools.nsw.gov.au/payment.html#/student-details";
      CONSTANTS.FETCH_USER_DATA =
        "https://test-doe-snsw.auth.ap-southeast-2.amazoncognito.com/oauth2/userInfo";
      CONSTANTS.PARENT_DEFAULT_ESSENTIALS =
        "https://portal.test.education.nsw.gov.au/portaldata/schools_default_essentials.json";
      CONSTANTS.SCHOOL_ESSENTIALS =
        "https://bookmarks.api.test.education.nsw.gov.au/test/essentials/";
      CONSTANTS.FETCH_NOTIFICATIONS =
        "https://parent.api.test.education.nsw.gov.au/notifications";
      break;
    case "pre":
      CONSTANTS.MIDDLEWARE = "https://parent.api.pre.education.nsw.gov.au";
      CONSTANTS.SCHOOL_STATUS = "https://api.dev.educationapp.nsw.edu.au/v2";
      CONSTANTS.EDPUSH_REGISTER =
        "https://edpush.api.pre.education.nsw.gov.au/api/v1/notifications/device/register-UUID";
      CONSTANTS.SCHOOL_PAYMENT_SUFFIX =
        "65.pre.schools.nsw.gov.au/payment.html#/student-details";
      CONSTANTS.FETCH_USER_DATA =
        "https://pre-doe-snsw.auth.ap-southeast-2.amazoncognito.com/oauth2/userInfo";
      CONSTANTS.PARENT_DEFAULT_ESSENTIALS =
        "https://portal.pre.education.nsw.gov.au/portaldata/schools_default_essentials.json";
      CONSTANTS.SCHOOL_ESSENTIALS =
        "https://bookmarks.api.pre.education.nsw.gov.au/pre/essentials/";
      CONSTANTS.FETCH_NOTIFICATIONS =
        "https://parent.api.pre.education.nsw.gov.au/notifications";
      break;
    case "prod":
      CONSTANTS.MIDDLEWARE = "https://parent.api.education.nsw.gov.au";
      CONSTANTS.SCHOOL_STATUS = "https://api.educationapp.nsw.edu.au/v2";
      CONSTANTS.EDPUSH_REGISTER =
        "https://edpush.api.education.nsw.gov.au/api/v1/notifications/device/register-UUID";
      CONSTANTS.SCHOOL_PAYMENT_SUFFIX =
        ".schools.nsw.gov.au/payment.html#/student-details";
      CONSTANTS.FETCH_USER_DATA =
        "https://doe-snsw.auth.ap-southeast-2.amazoncognito.com/oauth2/userInfo";
      CONSTANTS.PARENT_DEFAULT_ESSENTIALS =
        "https://portal.education.nsw.gov.au/portaldata/schools_default_essentials.json";
      CONSTANTS.SCHOOL_ESSENTIALS =
        "https://bookmarks.api.education.nsw.gov.au/prod/essentials/";
      CONSTANTS.FETCH_NOTIFICATIONS =
        "https://parent.api.education.nsw.gov.au/notifications";
      break;
    default:
      CONSTANTS.MIDDLEWARE = "https://parent.api.pre.education.nsw.gov.au";
      CONSTANTS.SCHOOL_STATUS = "https://api.dev.educationapp.nsw.edu.au/v2";
      CONSTANTS.EDPUSH_REGISTER =
        "https://edpush.api.pre.education.nsw.gov.au/api/v1/notifications/device/register-UUID";
      CONSTANTS.SCHOOL_PAYMENT_SUFFIX =
        "65.pre.schools.nsw.gov.au/payment.html#/student-details";
      CONSTANTS.FETCH_USER_DATA =
        "https://dev-doe-snsw.auth.ap-southeast-2.amazoncognito.com/oauth2/userInfo";
      CONSTANTS.PARENT_DEFAULT_ESSENTIALS =
        "https://portal.test.education.nsw.gov.au/portaldata/schools_default_essentials.json";
      CONSTANTS.SCHOOL_ESSENTIALS =
        "https://bookmarks.api.test.education.nsw.gov.au/test/essentials/";
      CONSTANTS.FETCH_NOTIFICATIONS =
        "https://parent.api.dev.education.nsw.gov.au/notifications";
  }
} else {
  CONSTANTS.MIDDLEWARE = process.env.VUE_APP_API_MIDDLEWARE;
  CONSTANTS.SCHOOL_STATUS = process.env.VUE_APP_API_SCHOOL_STATUS;
  CONSTANTS.EDPUSH_REGISTER = process.env.VUE_APP_API_EDPUSH_REGISTER;
  CONSTANTS.SCHOOL_PAYMENT_SUFFIX =
    process.env.VUE_APP_API_SCHOOL_PAYMENT_SUFFIX;
  CONSTANTS.FETCH_USER_DATA = process.env.VUE_APP_API_FETCH_USER_DATA;
  CONSTANTS.PARENT_DEFAULT_ESSENTIALS =
    process.env.VUE_APP_API_PARENT_DEFAULT_ESSENTIALS;
  CONSTANTS.SCHOOL_ESSENTIALS = process.env.VUE_APP_API_SCHOOL_ESSENTIALS;
  CONSTANTS.FETCH_NOTIFICATIONS = process.env.VUE_APP_API_FETCH_NOTIFICATIONS;
}

export default CONSTANTS;
// firebase analytics constants
export const FA_SCREEN_VIEW = "screen_view";
export const FA_SCREEN_CLASS = "screen_class";
export const FA_SCREEN_NAME = "screen_name";
export const FA_BUTTON_CLICK = "button_click";
